import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../i18n";

import kyndrylImage from "../assets/imgs/kyndryl.svg";
import educaImage from "../assets/imgs/educa.svg";
import nttImage from "../assets/imgs/NTTData.svg";
import ScrollReveal from "./ScrollReveal";

const experienceOrder = [
  { id: "begin", icon: null },
  { id: "trainee", icon: kyndrylImage },
  { id: "educa", icon: educaImage },
  { id: "nttdata", icon: nttImage },
  { id: "ia", icon: null },
];

function Experience() {
  const [activeIndex, setActiveIndex] = useState(0);
  const { language } = useLanguage();
  const [isFading, setIsFading] = useState(false);
  const [dividerPosition, setDividerPosition] = useState("25px");
  const [dividerHeight, setDividerHeight] = useState("100%");
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);
  const activeExperience = experienceOrder[activeIndex].id;
  const title = translations[language].experience[activeExperience].title;
  const text = translations[language].experience[activeExperience].text;
  const date = translations[language].experience[activeExperience].date;

  const changeIndex = (newIndex) => {
    setIsFading(true);

    const last = experienceOrder.length - 1;

    const isLeftEdge = newIndex <= 1 && activeIndex <= 1;
    const isRightEdge = newIndex >= last - 1 && activeIndex >= last - 1;

    if (isLeftEdge || isRightEdge) {
      setDividerHeight("0%");
    }

    setTimeout(() => {
      if (newIndex === 0) {
        setDividerPosition("25px");
      } else if (newIndex === experienceOrder.length - 1) {
        setDividerPosition("calc(100% - 25px)");
      } else {
        setDividerPosition("50%");
      }
    }, 300);

    setTimeout(() => {
      setActiveIndex(newIndex);
    }, 450);

    setTimeout(() => {
      setIsFading(false);
      setDividerHeight("100%");
    }, 700);
  };

  const minSwipeDistance = 50;

  const handleTouchStart = (e) => {
    setTouchEndX(null);
    setTouchStartX(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEndX(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStartX || !touchEndX) return;

    const distance = touchStartX - touchEndX;

    if (distance > minSwipeDistance) {
      // Swipe izquierda → siguiente
      if (activeIndex < experienceOrder.length - 1 && !isFading) {
        changeIndex(activeIndex + 1);
      }
    } else if (distance < -minSwipeDistance) {
      // Swipe derecha → anterior
      if (activeIndex > 0 && !isFading) {
        changeIndex(activeIndex - 1);
      }
    }
  };

  return (
    <div className="experience-container" id="experience-container">
      <div className="section-title">
        {">  " + translations[language].sectionTitles.experience}
      </div>
      <ScrollReveal delay={0.5}>
        <div
          className="experience-carousel-container"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div
            className={`experience-carousel-arrow ${
              activeIndex === 0 ? "disabled" : ""
            }`}
            onClick={() => {
              if (isFading) return;
              if (activeIndex > 0) {
                changeIndex(activeIndex - 1);
              }
            }}
          >
            {"<"}
          </div>
          <div className="experience-carousel-center">
            <div
              className="experience-carousel-divisor-line"
              style={{ left: dividerPosition, height: dividerHeight }}
            ></div>
            <div
              className={`experience-carousel-items-container ${
                activeIndex % 2 === 0 ? "reverse" : "normal"
              } ${isFading ? "fade-out" : "fade-in"}`}
            >
              <div className="experience-carousel-text-container">
                <div className="experience-carousel-title">{title}</div>
                <div className="experience-carousel-date">{date}</div>
                <div className="experience-carousel-text">{text}</div>
              </div>
              {experienceOrder[activeIndex].icon && (
                <div className="experience-carousel-icon">
                  <img
                    src={experienceOrder[activeIndex].icon}
                    alt="experience icon"
                  />
                </div>
              )}
            </div>
          </div>
          <div
            className={`experience-carousel-arrow ${
              activeIndex === experienceOrder.length - 1 ? "disabled" : ""
            }`}
            onClick={() => {
              if (isFading) return;
              if (activeIndex < experienceOrder.length - 1) {
                changeIndex(activeIndex + 1);
              }
            }}
          >
            {">"}
          </div>
        </div>
        <div className="experience-dots">
          {experienceOrder.map((_, index) => (
            <div
              key={index}
              className={`experience-dot ${
                index === activeIndex ? "active" : ""
              }`}
              onClick={() => {
                if (!isFading) changeIndex(index);
              }}
            />
          ))}
        </div>
      </ScrollReveal>
    </div>
  );
}

export default Experience;
